import React from 'react';

const Dropdown = ({ name, value, options, onChange, required, style, className }) => {
    return (
        <select name={name} value={value} onChange={onChange} required={required} style={style} className={className}>
            <option value="">Select...</option>
            {options.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    );
};

export default Dropdown;
